import { db } from '../../common/config/Firebase';
import moment from 'moment';

/**
 * Fetches time records for an employee for a date range
 * Uses collectionGroup to query across all year/month subcollections
 * @param {string} employeeId - Employee ID
 * @param {Date} startDate - Start date
 * @param {Date} endDate - End date
 * @returns {Promise<Array>} - Array of time records
 */
export const getTimeRecordsForRangeUseCase = async (employeeId, startDate, endDate) => {
    try {
        const start = moment(startDate).startOf('day').valueOf();
        const end = moment(endDate).endOf('day').valueOf();

        console.log(`Fetching records for employee ${employeeId} from ${moment(start).format('YYYY-MM-DD')} to ${moment(end).format('YYYY-MM-DD')}`);

        // Use collectionGroup to query all 'records' subcollections regardless of year/month
        const snapshot = await db
            .collectionGroup('records')
            .where('employeeId', '==', employeeId)
            .where('timestamp', '>=', start)
            .where('timestamp', '<=', end)
            .get();

        const allRecords = [];
        snapshot.forEach(doc => {
            allRecords.push({
                id: doc.id,
                ...doc.data()
            });
        });

        // Sort by timestamp
        allRecords.sort((a, b) => a.timestamp - b.timestamp);

        console.log(`Fetched ${allRecords.length} records for employee ${employeeId}`);
        console.log(allRecords);
        return allRecords;
    } catch (error) {
        console.error('Error fetching time records for range:', error);
        return []; // Return empty array to not break UI
    }
};

/**
 * Updates an existing time record
 * @param {string} employeeId - Employee ID
 * @param {string} recordId - Record ID
 * @param {number} timestamp - Record timestamp (to determine year/month)
 * @param {Object} updates - Fields to update
 * @returns {Promise<void>}
 */
export const updateTimeRecordUseCase = async (employeeId, recordId, timestamp, updates) => {
    try {
        const date = moment(timestamp);
        const year = date.format('YYYY');
        const month = date.format('MM');

        await db
            .collection('timeRecords')
            .doc(employeeId)
            .collection(year)
            .doc(month)
            .collection('records')
            .doc(recordId)
            .update({
                ...updates,
                modifiedAt: Date.now(),
                manualCorrection: true
            });

        console.log('Time record updated:', recordId);
    } catch (error) {
        console.error('Error updating time record:', error);
        throw error;
    }
};
